import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge } from '@criteria-labs/react';
import { formatTypeForSchema } from './formatTypeForSchema';
function SchemaTypeBadge({ children }) {
    return (_jsx(Badge, { className: "text-xs/5", color: "zinc", children: children }));
}
function SchemaFormatBadge({ children }) {
    return (_jsx(Badge, { className: "text-xs/5", color: "yellow", children: children }));
}
export function SchemaValidationBadges({ schema }) {
    const formattedType = formatTypeForSchema(schema);
    return (_jsxs("div", { className: "inline space-x-2", children: [formattedType && _jsx(SchemaTypeBadge, { children: formattedType }), typeof schema === 'object' && schema !== null && typeof schema.format === 'string' && (_jsx(SchemaFormatBadge, { children: schema.format }))] }));
}
